export const getEndpoint = () =>
  process.env.NODE_ENV === 'development'
    ? process.env.DEV_API_URI
    : process.env.API_URI
